'use strict';

goog.provide('Ntry.CanvasRenderer');

goog.require('Ntry.STATIC');

Ntry.CanvasRenderer = (function() {
    return function() {
        this._sprites = {};
        this._bitmaps = {};

        this._bitmapPath = '/img/assets/ntry/bitmap/';
        this._spritePath = '/img/assets/ntry/sprite/';

        this.createDom();
    };
})();

(function(p) {
    p.createDom = function() {
        const canvas = Ntry.interfaceManager.getDom('canvas');
        //$(canvas).dblclick(function(e) {
        //if (window.setFree && !window.isAdmin) {
        //window.setFree();
        //alert('free');
        //}
        //});
        this.canvasDom = canvas;
        this.canvas = new createjs.Stage(canvas);
    };

    p.loadConfig = function() {
        const gridSize = Ntry.configManager.getConfig('gridSize');
        const tileSize = Ntry.configManager.getConfig('tileSize');
        this.canvasDom.width = gridSize.width * tileSize;
        this.canvasDom.height = gridSize.height * tileSize;
        this.tileSize = tileSize;
        this._bitmapPath = Ntry.configManager.getConfig('bitmapPath');
        this.canvas.regX = Ntry.configManager.getConfig('canvasRegX');
    };

    p.update = function() {
        /* update bitmap */
        let entities = Ntry.entityManager.getEntitiesByComponent(Ntry.STATIC.BITMAP);

        let iterator = _.sortBy(_.toArray(entities), (entity) => entity.index);

        let entityKeys = Object.keys(this._bitmaps);

        for (var index in iterator) {
            var id = iterator[index].id;
            const bitmap = this.getBitmap(id);
            var position = Ntry.entityManager.getComponent(id, Ntry.STATIC.POSITION);
            const tile = Ntry.entityManager.getComponent(id, Ntry.STATIC.TILE);
            const bitmapComp = Ntry.entityManager.getComponent(id, Ntry.STATIC.BITMAP);
            bitmap.x = position.x;
            bitmap.y = position.y;
            bitmap.rotation = bitmapComp.rotation;
            bitmap.alpha = bitmapComp.opacity;
            bitmap.scaleX = bitmapComp.scaleX;
            bitmap.scaleY = bitmapComp.scaleY;
            entityKeys.splice(entityKeys.indexOf(id), 1);
        }

        for (var i in entityKeys) {
            this.removeBitmap(entityKeys[i]);
        }

        /* update sprite */
        entities = Ntry.entityManager.getEntitiesByComponent(Ntry.STATIC.SPRITE);
        iterator = _.sortBy(_.toArray(entities), (entity) => entity.index);

        entityKeys = Object.keys(this._sprites);

        for (var index in iterator) {
            var id = iterator[index].id;
            const sprite = this.getSprite(id);
            const spriteComp = Ntry.entityManager.getComponent(id, Ntry.STATIC.SPRITE);
            var position = Ntry.entityManager.getComponent(id, Ntry.STATIC.POSITION);
            sprite.x = position.x;
            sprite.y = position.y;
            sprite.scaleX = spriteComp.scaleX;
            sprite.regX = spriteComp.regX;
            sprite.rotation = spriteComp.rotation;
            sprite.alpha = spriteComp.opacity;
            sprite.sourceRect = {
                x: spriteComp.currentFrame * spriteComp.width,
                y: spriteComp.currentFrameKey * spriteComp.height,
                width: spriteComp.width,
                height: spriteComp.height,
            };
            // console.log(sprite.sourceRect);
            entityKeys.splice(entityKeys.indexOf(id), 1);
        }

        for (var i in entityKeys) {
            this.removeSprite(entityKeys[i]);
        }

        this.canvas.update();
    };

    p.getBitmap = function(entityId) {
        return this._bitmaps[entityId] || this.createBitmap(entityId);
    };

    p.createBitmap = function(entityId) {
        const bitmapComp = Ntry.entityManager.getComponent(entityId, Ntry.STATIC.BITMAP);
        let imgPath = this._bitmapPath;
        imgPath += bitmapComp.image;
        imgPath += '.png';
        const bitmap = new createjs.Bitmap(imgPath);
        if (bitmapComp.regX != null) {
            bitmap.regX = bitmapComp.regX;
        } else {
            bitmap.regX = this.tileSize / 2;
        }
        if (bitmapComp.regY != null) {
            bitmap.regY = bitmapComp.regY;
        } else {
            bitmap.regY = this.tileSize / 2;
        }
        this._bitmaps[entityId] = bitmap;
        this.canvas.addChild(bitmap);
        //this logging will be removed before deploy
        //console.log(entityId, imgPath);
        return bitmap;
    };

    p.removeBitmap = function(entityId) {
        const bitmap = this.getBitmap(entityId);
        this.canvas.removeChild(bitmap);
        delete this._bitmaps[entityId];
    };

    p.getSprite = function(entityId) {
        return this._sprites[entityId] || this.createSprite(entityId);
    };

    p.createSprite = function(entityId) {
        const spriteComp = Ntry.entityManager.getComponent(entityId, Ntry.STATIC.SPRITE);
        let imgPath = this._bitmapPath;
        imgPath += spriteComp.image;
        imgPath += '.png';
        const sprite = new createjs.Bitmap(imgPath);
        if (spriteComp.regY) {
            sprite.regY = spriteComp.regY;
        } else {
            sprite.regY = this.tileSize / 2;
        }
        sprite.regX = this.tileSize / 2;
        this._sprites[entityId] = sprite;
        this.canvas.addChild(sprite);
        return sprite;
    };

    p.removeSprite = function(entityId) {
        const sprite = this.getSprite(entityId);
        this.canvas.removeChild(sprite);
        delete this._sprites[entityId];
    };
})(Ntry.CanvasRenderer.prototype);
